'use client';

import { Typography } from '@musinsa/mds';

/**
 * 완료 탭 "콘텐츠 제출 기한 경과" 그룹 헤더. (QAT-39690 §3 / CMQA-7190, Figma 2453-40673)
 *
 * 정상 완료 그룹과 기한경과(미제출) 그룹 사이의 시각 구분선 역할. 위 간격(pt-12)은 직전 카드
 * `pb-12` 와 합쳐 그룹 경계를, 아래(pb-4)는 첫 기한경과 카드 `pt-4` 와 맞물린다.
 */
export const SeedingContentExpiredGroupHeader = () => (
  <div className="px-[16px]! pt-[12px]! pb-[4px]!">
    <Typography variant="body13pxReg" colorScheme="gray-600">
      콘텐츠 제출 기한 경과
    </Typography>
  </div>
);
